import './App.scss';
import './translationfix.scss';
import cssVar from './index.scss'
import React, { useState, useEffect, useContext } from 'react';
import { useGlobalContext } from './helper/DataMain';

import Menu from './components/Menu/Menu';
import FooterControl from './components/FooterControls/FooterControls';
import ResetView from './components/ResetView/ResetView';   // DN - added for reset view button
import HowToUse from './components/HowToUse/HowToUse';
import Arbutton from './components/Menu/Arbutton';
import GlobalDisclaimer  from './components/GlobalUtils/GlobalDisclaimer'; // DN - added for GlobalDisclaimer
import OverviewText  from './components/GlobalUtils/OverviewText'; // DN - added for OverviewText
import ProjectTitleMob  from './components/GlobalUtils/ProjectTitle'; // DN - added for ProjectTitle



function App() {
  const { jsonData } = useGlobalContext() || {};  
  let {ProjectTitle, QRSupport, LangugageTranslation, accordianClick, productId, onLoadActiveradioButton, onLoadActiveAccordionMobile, imageSequence, video, dimensions, skipInNextPrevious} = {...jsonData};
  window.config.imageSequenceStatus = (typeof imageSequence == 'boolean') ? imageSequence : false; //store image sequence flag @DS
  window.config.videoStatus = (typeof video == 'boolean') ? video : false; //store video flag @DS
  window.config.dimensions = (typeof dimensions == 'boolean') ? dimensions : false; //store dimensions flag @YK
  window.config.skipInNextPrevious = skipInNextPrevious; //store skip menu's in config @DS
  let allLangugages = Object.keys(jsonData.menus);
  const [isFirstAccordion, setIsFirstAccordion] = useState(false);

  const getUrlParams = (params) => {
    var url = new URL(window.location.href);
    // url = url.href;
    // console.log('url ', url)
    var paramsValue = url.searchParams.get(params);
    if(paramsValue == null || !LangugageTranslation || !allLangugages.includes(paramsValue.toUpperCase())) paramsValue = 'en';
    // console.log('paramsValue ', paramsValue);
    return paramsValue
  }
  
  // console.log('jsonData ', jsonData);
  
  let langCode = getUrlParams("locale").toLocaleUpperCase();
  
  const menuData = jsonData.menus[langCode];
  let menuSubmenu = menuData.filter(val => val.menuVisibility !== 'hide');
  let { ui } = menuSubmenu.shift();
  
  /*Add langCode as class in body*/
  let bodyTag = document.getElementsByTagName("BODY")[0]; 
  bodyTag.classList.add(langCode.toLowerCase()); 
  /*Add langCode as class in body end*/
  let cssVariableValues = {...cssVar};
  /*Get :root styles end */

  window.isMobIsipadIsPotrait = window.deviceBasedonBodyClass == 'ipadDesktopPortrait' || window.deviceBasedonBodyClass == 'mobilePortrait' || window.deviceBasedonBodyClass =='ipadPortrait'  || window.deviceBasedonBodyClass =='androidTabPortrait';;
  window.isipadLandscap = window.deviceBasedonBodyClass == 'ipadLandscape' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape';
  window.androidTabLandscape = window.deviceBasedonBodyClass == 'androidTabLandscape';
  
  // console.log('menuSubmenu ', menuSubmenu)
  // const [menuJsonData, setMenuJsonData] = useState([]);
  // console.log('jsonData ', jsonDatar);
  
  let jsonDataKeys = [];
  if(jsonData !== undefined && jsonData.length == undefined){
    jsonDataKeys = Object.keys(jsonData);
    // console.log('jsonDataKeys ', jsonDataKeys.length);
  }
  
  const getDOMElementsForTranslation = (ui) =>{
    // console.log('data ', data)
    let moveText = document.querySelector('#move_text');
    let rotateText = document.querySelector('#rotate_text');
    let zoomText = document.querySelector('#zoom_text');
    let exploreButtton = document.querySelector('#exploreButtton');
    let dummyFocus = document.querySelector('#dummyFocus');
    moveText.innerHTML = ui.move;
    rotateText.innerHTML = ui.rotate;
    zoomText.innerHTML = ui.zoom;
    exploreButtton.innerHTML = ui.exploreProductIn3D;
    // dummyFocus.ariaLabel = ProjectTitle+' Real Time Viewer';
    // console.log('window.uiObj ', window.UiUtils.updateAriaLabel)
    window.UiUtils.updateAriaLabel('getDOMElementsForTranslation', dummyFocus, ProjectTitle);

    // console.log(moveText.innerHTML)
  }

  
  if(jsonDataKeys.length != 0){
    
    // console.log('langCode ', langCode)
    // {ProjectTitle, QRSupport, LangugageTranslation, accordianClick, productId} = {...jsonData}
    
    // console.log('menuData ', menuData);
    // getDOMElementsForTranslation(ui);
    document.title = ProjectTitle;
    window.ProjectTitle = ProjectTitle;
    // setMenuJsonData(menuData);
    // console.log('menuJsonData ', menuJsonData)
  }

    
    const [count, setCount] = useState(0);
    window.shouldReRenderMenu = true;
    window.reRenderMenu = () => {
      setCount(count + 1);
      setIsFirstAccordion(false); // Resetting isFirstAccordion to false on re-render
    }
if (!window.selectedConfig.hiddenHotspots) {
  window.selectedConfig.hiddenHotspots = []; // Array to track hidden hotspot IDs
}
    useEffect(() => {
      // Perform your action here
      // console.log("App Component has loaded");
      setTimeout(window.UiUtils.getDOMElementsinObject, 1000)
      // window.getDOMElementsinObject();
    }, []); // Empty dependency array

    //   useEffect(() => {
    //     console.log('useEffect menuJsonData productTypeList ', jsonData);
        
    //     // reRenderMenu();
    // }, [jsonData])

    /*MENU */
  // window.addEventListener('load', () => {
  //   // Check if the device is mobile/iPad in portrait
  //   if (window.isMobIsipadIsPotrait) {
  //     // console.log('Page loaded on mobile/iPad in portrait');

  //     // Decide which AR button to click
  //     const arButtonId = window.isIpadOrIphoneforAr ? 'btnXR-iphone' : 'btnXR';
  //     const arButton = document.getElementById(arButtonId);

  //     if (arButton) {
  //       // console.log('Automatically clicking AR button:', arButtonId);
  //       arButton.click();
  //     } else {
  //       // console.log('AR button not found:', arButtonId);
  //     }
  //   }

  // });

const accordionMenu = (data, id, isFromNextPrevious = false) => {
     window.handleOverviewText();

  // Mobile: AR button trigger
  // if (data.id === 'arpopup' && window.isMobIsipadIsPotrait) {
  //   console.log('AR accordion clicked on mobile');
    
  //   const arButtonId = window.isIpadOrIphoneforAr ? 'btnXR-iphone' : 'btnXR';
  //   const arButton = document.getElementById(arButtonId);
    
  //   if (arButton) {
  //     console.log('Clicking AR button:', arButtonId);
  //     arButton.click();
  //   }
  //   return;
  // }
  window.hidePopUpandHotspot();
  window.selectedConfig.currentSelectedHotspot = '';
    window.selectedConfig.currentSelectedAccordion = id;
    
  const cameraType = data?.cameraType || '';
// console.log(cameraType, window.previousCameraType)
  if (cameraType !== window.previousCameraType && window.previousCameraType !== undefined) {
    window.fadeIn?.(); // DN - commented to avoid fadeIn on first load
  }
  window.previousCameraType = cameraType;

  window.selectedConfig['currentSelectedSubmenu'] = data.id;
  
  // 🔥 FIX: Use FILTERED array (same as nextPreviousHandler) to store correct index
  let nextPrevArray = [...window.config.nextPrevArray];
  const allSubmenu = [...(window.config.allSubmenu || [])];
  const autoTriggeredSeq = new Set();
  
  // Apply same filtering logic as nextPreviousHandler
  allSubmenu.forEach(sub => {
    if (sub && sub.popupBoxButtons && sub.popupBoxButtons.length > 0) {
      const pb = sub.popupBoxButtons[0];
      const first = pb.firstButton || Object.values(pb)[0];
      if (first && first.sequenceName) autoTriggeredSeq.add(first.sequenceName);
    }
  });

  nextPrevArray = nextPrevArray.filter(item => {
    if (item && item.type === 'popupBoxButton' && autoTriggeredSeq.has(item.sequenceName)) return false;
    if (
      item &&
      item.sequenceName &&
      autoTriggeredSeq.has(item.sequenceName) &&
      !item.parentSubmenuId &&
      (!item.items || item.items.length === 0) &&
      !item.popupBoxButtons
    ) return false;
    return true;
  });
  
  // Now find index in the FILTERED array
  let clickedIndex = nextPrevArray.findIndex(item => item.id === data.id);
  if (clickedIndex !== -1) {
    window.selectedConfig.currentSelectedSubmenuIndex = clickedIndex;
    // console.log('✓ accordionMenu - Stored correct index:', clickedIndex, 'for:', data.id, '(in filtered array context)');
    window.selectedConfig.hasNavigatedBefore = true;
  }
  window.selectedConfig.submenu_Exterior = '';
  window.selectedConfig.submenu_Exploded_View = '';

  window.clearCalloutCanvas();
  let previousSelectedAccordionMenu = document.querySelector('.accordionMenu.active');
  
  const currentAccordion = document.querySelector(`#${id}`);
  //NEW - Clear all active submenu buttons
  document.querySelectorAll('.subMenuBtn.active:not(.radioButton)').forEach(btn => {
    // if(mode !== 'nextPrevious'){
    btn.classList.remove('active');
    // }
  });
  //arpopup double click - re-activate popup (don't return)
  // if (data.id === 'arpopup' && previousSelectedAccordionMenu && previousSelectedAccordionMenu.id === id) {
  //   // console.log('arpopup double-clicked - re-activating popup');
    
  //   // Re-activate popup
  //   setTimeout(() => {
  //     document.querySelectorAll('.popup.active').forEach(popup => {
  //       popup.classList.remove('active');
  //     });
      
  //     const arPopupId = data.popupId || id;
  //     const arPopup = document.getElementById(arPopupId);
      
  //     if (arPopup) {
  //       arPopup.classList.add('active');
  //     }
  //   }, 100);
    
  //   return; // Return after re-activation
  // }
    window.config.navigationDisabled = data && data.hasOwnProperty("navigationDisabled") && data.navigationDisabled === true;

  // Modified: Only collapse if not from next/previous navigation
  if (!isFromNextPrevious && data.id !== 'arpopup' && previousSelectedAccordionMenu && previousSelectedAccordionMenu.id === id) {
    // console.log('Toggle: Collapsing accordion', id);
    previousSelectedAccordionMenu.classList.remove('active');
    previousSelectedAccordionMenu.setAttribute('aria-expanded', 'false');
    
    const accordionContent = currentAccordion.nextSibling;
    if (accordionContent) {
      accordionContent.style.height = '0px';
    }
    
    window.UiUtils.handleUIwithMenuClick(data);
    window.UiUtils.handle3DwithMenuClick(data, 'menu');
    return;
  }
  
  // Modified: Only remove active if it's a different accordion
  if (previousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) {
    let previousSelectedAccordionMenuType = previousSelectedAccordionMenu.id.split('accordion_')[1];
    var accordionElem = document.getElementById(id);
    var accordionContentPreviousSelectedAccordionMenu = null;
    if(accordionElem && accordionElem.nextElementSibling) {
      accordionContentPreviousSelectedAccordionMenu = accordionElem.nextElementSibling.firstChild;
    }

    let activeSubmenuPreviousSelectedAccordionMenu = accordionContentPreviousSelectedAccordionMenu?.querySelector('.subMenuBtn.active');
    if(activeSubmenuPreviousSelectedAccordionMenu && !activeSubmenuPreviousSelectedAccordionMenu.classList.contains("radioButton")) {
      activeSubmenuPreviousSelectedAccordionMenu.classList.remove('active');
    }

    previousSelectedAccordionMenu.classList.remove('active');
    previousSelectedAccordionMenu.setAttribute('aria-expanded', 'false');
    window.calloutObj = null;
  }
  
  let isAccordion = document.querySelector(`#${id}`) !== null;
  let isPreviousSelectedAccordionMenu = previousSelectedAccordionMenu !== null;

  if(!isPreviousSelectedAccordionMenu && isAccordion) {
    document.querySelector(`#${id}`).classList.add('active');
    document.querySelector(`#${id}`).setAttribute('aria-expanded', 'true');
  } else if((isPreviousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) && isAccordion){
    document.querySelector(`#${id}`).classList.add('active');
    document.querySelector(`#${id}`).setAttribute('aria-expanded', 'true');
  }
  
  manageAccordionContentHeight(id, isPreviousSelectedAccordionMenu, isAccordion, previousSelectedAccordionMenu);
  
  let hotspotData = null;
  if(data['content'] !== undefined && data['content'].length !== 0){
    hotspotData = data['content'].filter(filterMenuBasedOnConfigType);
  } else{
    window.clearCalloutCanvas();
  }
  
  window.UiUtils.handleUIwithMenuClick(data);
  window.UiUtils.handle3DwithMenuClick(data, 'menu');
  if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('accordionMenu', id);
  if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaHidden('accordionMenu', id);
  
  // 🔥 First time click: Activate AR popup
  if (data.id === 'arpopup' || data.id === 'Exploded_View') {
    setTimeout(() => {
      document.querySelectorAll('.popup.active').forEach(popup => {
        popup.classList.remove('active');
      });
      
      const arPopupId = data.popupId || id;
      const arPopup = document.getElementById(arPopupId);
      
      if (arPopup) {
        // console.log('Activating AR popup:', arPopupId);
        arPopup.classList.add('active');
      }
    }, 300);
  }
}




const manageAccordionContentHeight = (id, isPreviousSelectedAccordionMenu, isAccordion, previousSelectedAccordionMenu) => {
  if (!id || !document.getElementById(id)) {
    // console.log('Invalid accordion ID:', id);
    return;
  }
  var accordionContentAll = document.querySelectorAll('.accordionContent');
  if (!window.selectedConfig['selectedAccordion'] || window.selectedConfig['selectedAccordion'].length > 0) {
    window.selectedConfig['selectedAccordion'] = [];
  }
  
  if (!window.isMobIsipadIsPotrait) {
    for (var i = 0; i <= accordionContentAll.length - 1; i++) {
      accordionContentAll[i].style.height = '0px';
    }
    
    const accordionElement = document.getElementById(id);
    if (!accordionElement || !accordionElement.nextSibling) {
      // console.log('Accordion element or its nextSibling not found');
      return;
    }

    var accordionContentElem = accordionElement.nextSibling.firstChild;
    
    if (!accordionContentElem || !accordionContentElem.hasChildNodes()) {
      accordionElement.nextSibling.style.height = '0px';
      accordionElement.classList.add('active');
      return;
    }
    

    accordionElement.nextSibling.style.height = accordionContentElem.offsetHeight + 'px';
    if (accordionElement.nextSibling.style.height !== '0px') {
      if (!window.selectedConfig['selectedAccordion'].includes(id)) {
        window.selectedConfig['selectedAccordion'].push(id);
      }
    }
  } else {
    if (!window.selectedConfig['selectedAccordion'].includes(id)) {
      window.selectedConfig['selectedAccordion'] = [id];
    }
  }
}

let hotspotDataInfo = null;

    //  let isFirstAccordion = false; // this variable is used to check if first accordion is active or not, used in next/previous functionality
const handleSubMenuClick = (data, id, nextPreviousHandler, badgeStatus, hotspotDataInfo, isFromNextPrevious = false) => {
     window.handleOverviewText();
  badgeStatus = data.badge;
//  console.log('handleSubMenuClick data ', data, ' isFromNextPrevious ', isFromNextPrevious);
  const cameraType = data?.cameraType || '';
  // console.log('Camera type for submenu click:', cameraType);
  if (cameraType !== window.previousCameraType) {
    // console.log('Camera type changed from 1111', window.previousCameraType, 'to', cameraType);
    window.fadeIn?.();
  }
  window.previousCameraType = cameraType;

  if (!(window.mob || window.ipad || window.androidTab))  if (typeof window.updateSlider === "function") window.updateSlider();
  
  window.clearCalloutCanvas();
  window.calloutObj = [];
  
  //Clear hotspot state when normal submenu is clicked
  window.selectedConfig['currentSelectedHotspot'] = null;
  
  // Close ALL popups (including hotspot popups)
  document.querySelectorAll('.popup.active').forEach(popup => {
    popup.classList.remove('active');
  });

  let currentSelectedSubMenu = document.querySelector(`#menu_id_${data.id}`);
  
  if (window.isMobIsipadIsPotrait) {
    window.selectedConfig.drawHotspotCircleMobile = !currentSelectedSubMenu.classList.contains('active');
  }
  
  let isradioButton = currentSelectedSubMenu ? currentSelectedSubMenu.classList.contains('radioButton') : null;
  const closestsubMenu = currentSelectedSubMenu ? currentSelectedSubMenu.closest(".subMenu") : null;
  let previousSelectedAccordionMenu = closestsubMenu ? closestsubMenu.querySelector('.subMenuBtn.active') : null;

  if (isradioButton) {
    document.querySelector(`#menu_id_${data.id} input[type='radio']`).checked = true;
    let radioGroup = document.querySelectorAll(`input[name='${data.radioName}']`);

    window.selectedConfig[data.featureType] = data.id;

    radioGroup.forEach(radio => {
      let subMenuBtn = radio.closest(".subMenuBtn");
      if (subMenuBtn.classList.contains('active')) subMenuBtn.classList.remove('active');
    });

    document.querySelector(`#menu_id_${data.id}`).classList.add('active');

    let nonRadioSubmenu = document.querySelectorAll('.subMenuBtn.active');
    let nonRadioSubmenuArray = [...nonRadioSubmenu];
    nonRadioSubmenuArray.forEach(submenu => {
      if (!submenu.classList.contains('radioButton')) {
        submenu.classList.remove('active');
        let selectedConfigKeys = Object.keys(window.selectedConfig);
        selectedConfigKeys.forEach(selectedConfigKey => {
          if (selectedConfigKey.includes('submenu_')) {
            window.selectedConfig[selectedConfigKey] = "";
          }
        });
      }
    });
  } else {
    // Modified logic for active class handling
    if (isFromNextPrevious) {
      // For navigation, always add active to current, don't remove from previous unless different
      // console.log('currentSelectedSubMenu', currentSelectedSubMenu);
      if (currentSelectedSubMenu) {
        currentSelectedSubMenu.classList.add('active');
      }
      // Only remove active from previous if it's a different submenu
      // if(previousSelectedAccordionMenu && previousSelectedAccordionMenu.id.includes('menu_id_menu_id_')) {
      //   previousSelectedAccordionMenu.id = previousSelectedAccordionMenu.id.replace('menu_id_menu_id_','menu_id_');
      // }
      // console.log('previousSelectedAccordionMenu', data.id);
      let ignoreList = ['color']; // Add IDs to ignore list
      if (previousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== data.id && !ignoreList.includes(data.id)) {
        previousSelectedAccordionMenu.classList.remove('active');
      }
    } else {
      // For manual clicks, remove from previous and add to current if not already active
      // if (previousSelectedAccordionMenu) previousSelectedAccordionMenu.classList.remove('active');
      if (currentSelectedSubMenu && !currentSelectedSubMenu.classList.contains('active')) {
        currentSelectedSubMenu.classList.add('active');
      }
    }
  }

  let isSubmenuAlreadySelectedForMobIpadPortrait = window.isMobIsipadIsPotrait && (window.selectedConfig['submenu_' + data.type] === window.selectedConfig['previous_submenu_' + data.type]) && window.selectedConfig['submenu_' + data.type] != undefined;

  // 🔥 Show only current submenu's popup (not hotspot popup)
  let curruntActivePopup = document.getElementById(data.popupId);
  if (curruntActivePopup) {
    curruntActivePopup.classList.add('active');
  }
  
  if (isSubmenuAlreadySelectedForMobIpadPortrait) {
    window.selectedConfig['previous_submenu_' + data.type] = "";
  } else {
    window.selectedConfig['previous_submenu_' + data.type] = window.selectedConfig['submenu_' + data.type];
  }
  window.selectedConfig['submenu_' + data.type] = data.id;
  window.selectedConfig['currentSelectedSubmenu'] = data.id;

  // 🔥 FIX: Use FILTERED array (same as nextPreviousHandler) to store correct index
  let nextPrevArray = [...window.config.nextPrevArray];
  const allSubmenuForFilter = [...(window.config.allSubmenu || [])];
  const autoTriggeredSeqForFilter = new Set();
  
  // Apply same filtering logic as nextPreviousHandler
  allSubmenuForFilter.forEach(sub => {
    if (sub && sub.popupBoxButtons && sub.popupBoxButtons.length > 0) {
      const pb = sub.popupBoxButtons[0];
      const first = pb.firstButton || Object.values(pb)[0];
      if (first && first.sequenceName) autoTriggeredSeqForFilter.add(first.sequenceName);
    }
  });

  nextPrevArray = nextPrevArray.filter(item => {
    if (item && item.type === 'popupBoxButton' && autoTriggeredSeqForFilter.has(item.sequenceName)) return false;
    if (
      item &&
      item.sequenceName &&
      autoTriggeredSeqForFilter.has(item.sequenceName) &&
      !item.parentSubmenuId &&
      (!item.items || item.items.length === 0) &&
      !item.popupBoxButtons
    ) return false;
    return true;
  });
  
  // Now find index in the FILTERED array
  let clickedIndex = nextPrevArray.findIndex(item => item.id === data.id);
  if (clickedIndex !== -1) {
    window.selectedConfig.currentSelectedSubmenuIndex = clickedIndex;
    // console.log('✓ handleSubMenuClick - Stored correct index:', clickedIndex, 'for:', data.id, '(in filtered array context)');
    window.selectedConfig.hasNavigatedBefore = true;
  }

  if (data.hasOwnProperty('updateSubmenuList') && Object.keys(data.updateSubmenuList).length > 0) {
    let updateSubmenuListKeys = Object.keys(data.updateSubmenuList);
    updateSubmenuListKeys.forEach(property => {
      window.selectedConfig[property] = data.updateSubmenuList[property];
    });
  }
const allActive = document.querySelectorAll(".tempHotspot.active");
allActive.forEach(el => el.classList.remove("active"));
  let accordionID = `accordion_${data.type}`;
  let accordion = document.querySelector(`#${accordionID}`);
  let previousActiveAccordion = document.querySelector('.accordionMenu.active');
  if (previousActiveAccordion !== null && previousActiveAccordion.id !== accordionID) previousActiveAccordion.classList.remove('active');
  if (accordion !== null && !accordion.classList.contains('active')) {
    accordion.classList.add('active');
    manageAccordionContentHeight(accordionID, previousSelectedAccordionMenu !== null, accordion !== null, previousSelectedAccordionMenu);
  }
  if (accordion !== null) {
    manageAccordionContentHeight(accordionID, previousSelectedAccordionMenu !== null, accordion !== null, previousSelectedAccordionMenu);
  }

  let hotspotData = null;
  if (data['content'] !== undefined && data['content'].length !== 0) {
    hotspotData = data['content'].filter(filterMenuBasedOnConfigType);
  } else {
    window.clearCalloutCanvas();
  }

  if (data['hotspotDataInfo'] !== undefined && data['hotspotDataInfo'].length !== 0 && window.config.dimensions) {
    hotspotDataInfo = data['hotspotDataInfo'];
  }

  window.resetRotationCenter();

  if (window.shouldReRenderMenu) window.reRenderMenu();

  window.UiUtils.handleUIwithMenuClick(data);
  if (hotspotData) window.UiUtils.handleHotspotwithMenuClick(hotspotData);
  window.UiUtils.handle3DwithMenuClick(data, 'submenu');

  // debugger;
  if (hotspotDataInfo && Array.isArray(hotspotDataInfo) && hotspotDataInfo.length > 0 && window.config.dimensions) {
    // window.UiUtils.handleHotspotwithMenuClick(hotspotDataInfo);
    window.UiUtils.handleDimensionsActivation(hotspotDataInfo);
  }
  window.config.navigationDisabled = data && data.hasOwnProperty("navigationDisabled") && data.navigationDisabled === true;
  // console.log('isnavigationDisabled ', navigationDisabled);

  setTimeout(function () {
    if (window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('handleSubMenuClick', data.id, accordionID, nextPreviousHandler);
  }, 100);
  setTimeout(function () {
    if (window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('handleSubMenuClick', data, accordionID, nextPreviousHandler);
  }, 200);

  if (data.type !== 'positionView' && window.selectedConfig.hasOwnProperty("submenu_positionView")) {
    setTimeout(function () {
      window.selectedConfig['submenu_positionView'] = "";
    }, 500);
  }

  if (data.hasOwnProperty('updateAccordionVisibility') && data.updateAccordionVisibility.length > 0) {
    setIsFirstAccordion(true);
  } else {
    setIsFirstAccordion(false);
  }
// if (window.isMobIsipadIsPotrait && !nextPreviousHandler) {
//   setTimeout(() => {
//     const submenuButtons = document.querySelectorAll('.subMenuBtn.active');

//     const header = document.querySelector('header');
//     const headerHeight = header ? header.offsetHeight : 0;

//     submenuButtons.forEach((submenuButton, index) => {
//       setTimeout(() => {
//         submenuButton.scrollIntoView({
//           behavior: 'smooth',
//           block: 'start'
//         });

//         setTimeout(() => {
//           window.scrollTo({
//             top: window.pageYOffset - headerHeight,
//             behavior: 'smooth'
//           });
//         }, 100);
//       }, index * 200); // stagger scroll for multiple buttons
//     });
//   }, 600);
// }

  // console.log('After menu click:');
  // console.log('currentSelectedSubmenu:', window.selectedConfig.currentSelectedSubmenu);
  // console.log('isFirstTimeNavigation:', window.selectedConfig.isFirstTimeNavigation);
  // console.log("data", data);
  if(data.hotspotDataInfo){
    // console.log("hotspotDataInfo", data.hotspotDataInfo);
    window.selectedConfig.hotspotDataInfo = [];
    data.hotspotDataInfo.forEach((hotspot) => {
      // console.log("hotspot", hotspot);
      window.selectedConfig.hotspotDataInfo.push(hotspot.htmlid);
     });

  }
}




      
// App component ke andar
const [forceUpdate, setForceUpdate] = useState(0);

const handleHotspotClick = (parentSubmenuIdOrData, hotspotData, shouldAutoShowPopup = true, clickedHotspotId = null) => { 
window.UiUtils.stopAllVideos();
 window.hidePopUpandHotspot();
  const parentSubmenuId = typeof parentSubmenuIdOrData === "object" ? parentSubmenuIdOrData.id : parentSubmenuIdOrData;

  let targetHotspotId = clickedHotspotId;
  if (!targetHotspotId && hotspotData?.length) {
    targetHotspotId = hotspotData[0].hsname || hotspotData[0].htmlid;
  }

  const hotspotItem =
    hotspotData?.find(
      (h) => h.hsname === targetHotspotId || h.htmlid === targetHotspotId
    ) || hotspotData?.[0];

  // console.log("Hotspot clicked:", targetHotspotId, "in submenu:", parentSubmenuId);
    const cameraType = hotspotItem?.cameraType;
    // console.log("🔥 Hotspot cameraType:", cameraType, "Previous cameraType:", window.previousCameraType);
    if (cameraType) {
      // console.log("🔥 Hotspot cameraType:", cameraType);
      if (cameraType !== window.previousCameraType) {
        window.fadeIn?.();
      }
      window.previousCameraType = cameraType;
    }
  // hotspot show/hide logic
  const hsId = hotspotItem?.htmlid;
  if (hsId) {
    window.selectedConfig.hotspotDataInfo.forEach((hotspotId) => {
      const hotspotEl = document.querySelector(`#${hotspotId}.tempHotspot`);
      if (hotspotEl) hotspotEl.classList.remove("d-none");
    });

    const selectedHotspotEl = document.querySelector(`#${hsId}.tempHotspot`);
    if (selectedHotspotEl) selectedHotspotEl.classList.add("d-none");
  }

  window.selectedConfig.currentSelectedHotspot =
    hotspotItem?.hsname || hotspotItem?.htmlid;

  window.selectedConfig.hotspotData = hotspotData;

  // Popup logic
  if (shouldAutoShowPopup && hotspotItem) {
    setTimeout(() => {
      const popupId = `hotspot_popup_${window.selectedConfig.currentSelectedHotspot}`;
      const popupEl = document.getElementById(popupId);
      if (popupEl) {
        document.querySelectorAll(".popup.active").forEach((p) => p.classList.remove("active"));
        popupEl.classList.add("active");
      }
    }, 100);
  }

  setForceUpdate((prev) => prev + 1);

  // navigationDisabled logic
  if (!window.config) window.config = {};
  if (hotspotItem && hotspotItem.hasOwnProperty("navigationDisabled")) {
    window.config.navigationDisabled = hotspotItem.navigationDisabled === true;
  } else {
    window.config.navigationDisabled = false;
  }

  // Sequence logic
  if (hotspotItem) {
    const hotspotSequenceName = hotspotItem.hotspotSequenceName;

    if (hotspotSequenceName && typeof window[hotspotSequenceName] === "function") {
      window.scene.applySequence(window[hotspotSequenceName]);
      window.selectedConfig.selectedSequence = hotspotSequenceName;
    }
  }

  //  NEW — hotspot video handled through ui.js only
  const hotspotVideoId = `${parentSubmenuId}_${hotspotItem.htmlid || hotspotItem.hsname}`;
  window.UiUtils.playPausevideoClick(hotspotVideoId, hotspotItem);

  // Repeat sequence logic kept same (your original code)
  if (
    hotspotItem?.hotspotSequenceName &&
    typeof window[hotspotItem.hotspotSequenceName] === "function"
  ) {
    window.scene.applySequence(window[hotspotItem.hotspotSequenceName]);
    window.selectedConfig.selectedSequence = hotspotItem.hotspotSequenceName;
  }
};


const popupButtonClicks = (btn) => {
  // alert('popupButtonClicks called');
  if (!btn) return;

  // 🔹 Make sure the popup is active by updating currentSelectedSubmenu
  // For buttons (firstButton, secondButton), track the button ID so Next/Previous works correctly
  if (btn.parentSubmenuId) {
    // If it's a button from manual click, set to button ID
    // If it's from nextPreviousHandler, don't overwrite (it has type: 'popupBoxButton')
    if (btn.type !== 'popupBoxButton') {
      // Check if this is a button (firstButton, secondButton pattern)
      if (btn.id === 'firstButton' || btn.id === 'secondButton') {
        window.selectedConfig.currentSelectedSubmenu = btn.id;
      } else {
        window.selectedConfig.currentSelectedSubmenu = btn.parentSubmenuId;
      }
    }
  }

  // 🔹 Close all existing popups
  document.querySelectorAll('.popup.active').forEach(p => {
    p.classList.remove('active');
  });

  // 🔹 Show popup
  const popupId = btn.popupId;
  const popupEl = document.getElementById(popupId);
  // console.log('popupEl ', popupEl)

  if (popupEl) {
    popupEl.classList.add('active');
  }

  // 🔹 Sequence change
  if (btn.sequenceName && typeof window[btn.sequenceName] === 'function') {
    window.scene.applySequence(window[btn.sequenceName]);
    window.selectedConfig.selectedSequence = btn.sequenceName;
  }

  // 🔹 Navigation disable if needed
  if (btn.hasOwnProperty("navigationDisabled")) {
    window.config.navigationDisabled = btn.navigationDisabled === true;
  } else {
    window.config.navigationDisabled = false;
  }
};


     
    /*MENU END */

    /*Code to check configType of main accordion and show/hide the menu based on configType if any*/
    const filterMenuBasedOnConfigType = (list => {
        
        let isConfigTypeAvailable = list.hasOwnProperty("configType");
        let showaccordion = false;
        let showaccordionArray = [];
        if(isConfigTypeAvailable) {
        let listConfigType = Object.keys(list.configType);
        // console.log('calloutTextConfigType ', calloutTextConfigType)
        listConfigType.forEach(configTypeText => {

        if(list.configType[configTypeText] && window.selectedConfig[configTypeText] && list.configType[configTypeText].toLowerCase() == window.selectedConfig[configTypeText].toLowerCase()){
            showaccordionArray.push('true');
        } else {
            showaccordionArray.push('false');
        }
        
        });
        } else {
            showaccordionArray.push('true');
        }
        if(showaccordionArray.includes('false')){
            showaccordion = false;
        } else {
            showaccordion = true;
        }
        return showaccordion;
        
    });
    /*Code to check configType of main accordion and show/hide the menu based on configType if any end*/

    /*calculate HTMl element actul width without wrap */
    const calcHtmlElementNoWrapWidth = (text, fontSize) => {
      let dummyEle = document.createElement('p');
      dummyEle.id = 'dummyEle';
      dummyEle.classList.add('dummyEle');
      dummyEle.style.width = 'max-content';
      dummyEle.style.fontSize = parseInt(fontSize)+'px';
      dummyEle.innerText = text;
      
      document.body.append(dummyEle);
      let maxWidth = dummyEle.offsetWidth;
      dummyEle.remove();
      return maxWidth;

    }
    /*calculate HTMl element actul width without wrap end */

    /*Footer Controls */
    const onPreviousMode = () => {
      nextPreviousHandler('previous');
      window.UiUtils.handleUIwithMenuClick();
    }
    const onNextMode = () => {
      
      /*
      let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
      let nextPrevArray = [...window.config.nextPrevArray];
      console.log('Next currentSelectedSubmenu.... ', currentSelectedSubmenu);
      console.log('Next clicked.... ', nextPrevArray);

      let currentSelectedSubMenuIndex = nextPrevArray.findIndex(menuList => {
        return menuList.id === currentSelectedSubmenu;
      });

      console.log('Next clicked.... nextPrevArray', nextPrevArray.length-1);
      console.log('Next clicked.... currentSelectedSubMenuIndex', currentSelectedSubMenuIndex);
      if(currentSelectedSubMenuIndex === nextPrevArray.length-1) currentSelectedSubMenuIndex = -1; 
      let nextElement = nextPrevArray[currentSelectedSubMenuIndex+1];
      let nextElementID = nextElement.id; 
      */
      nextPreviousHandler('next');


      // let accordionID = 'accordion_'+nextElement.type;
      // let accordionID = `accordion_${nextElement.type}`;
      // let accordion = document.querySelector(`#${accordionID}`);
      // console.log('nextElement ', accordionID);
      // if(!accordion.classList.contains('active')) accordion.classList.add('active');
      // window.UiUtils.handleUIwithMenuClick(); //@YK commented as we have called handleSubMenuClick in nextPreviousHandler so this function gets called 2 times so commented
    }
    // const onReset = () => {
    //   let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
    //   let allSubmenu = [...window.config.allSubmenu];
    //   let currentSelectedSubMenuObj= allSubmenu.filter(menuList => {
    //       return menuList.id === currentSelectedSubmenu;
    //     });
    //     // console.log('currentSelectedSubMenuObj ', currentSelectedSubMenuObj)
    //     currentSelectedSubMenuObj = currentSelectedSubMenuObj[0];
    //     // console.log('currentSelectedSubMenuObj ', currentSelectedSubMenuObj)
        
    //     // if(currentSelectedSubMenuObj === undefined) currentSelectedSubMenuObj = 'Normal_Reset'
    //   window.UiUtils.handleUIwithMenuClick();
    //   window.UiUtils.handle3DwithMenuClick(currentSelectedSubMenuObj, 'reset');
    // }

const onReset = () => {
  if(window.selectedConfig.currentSelectedSubmenu =="pen2in1") window.onResetClick = true;
 if(window.selectedConfig.currentSelectedSubmenu == '') window.handleOverviewText(true);

  const selectedConfig = window.selectedConfig || {};

  const hotspotData = selectedConfig.hotspotData || [];
  const currentHotspotId = selectedConfig.currentSelectedHotspot;
// console.log(window.selectedConfig);
  // --- REMOVE ACTIVE CLASS FROM HOTSPOT ---
const hsId = window.selectedConfig.currentSelectedHotspot;
if (hsId) {
  const selectedHotspotEl = document.querySelector(`#${hsId}.tempHotspot`);
  if (selectedHotspotEl) selectedHotspotEl.classList.add("d-none");
}

  // --- If last clicked was a hotspot ---
  const hotspotItem = hotspotData.find(
    h => h.hsname === currentHotspotId || h.htmlid === currentHotspotId
  );

  if (hotspotItem) {
    // restore hotspot 3D sequence
    if (hotspotItem.hotspotSequenceName && typeof window[hotspotItem.hotspotSequenceName] === "function") {
      window.scene.applySequence(window[hotspotItem.hotspotSequenceName]);
    }

    // show hotspot popup again
    setTimeout(() => {
      document.querySelectorAll('.popup.active').forEach(p => p.classList.remove('active'));
      const popupId = "hotspot_popup_" + currentHotspotId;
      const popupEl = document.getElementById(popupId);
      if (popupEl) popupEl.classList.add("active");
    }, 300);

    return; // IMPORTANT: Don't continue to normal reset, hotspot handled here
  }

  // ---- Else normal submenu reset fallback ----
  const currentID = selectedConfig.currentSelectedSubmenu;
  const allSubmenu = [...(window.config.allSubmenu || [])];
  // console.log('onReset currentID:', currentID);
  // console.log('onReset allSubmenu:', allSubmenu);

  let menuObj = window.config.nextPrevArray.find(m => m.id === currentID);

  window.UiUtils.handleUIwithMenuClick();
  window.UiUtils.handle3DwithMenuClick(menuObj, "reset");

  const currentSelectedSubMenuObj = allSubmenu.find((m) => m.id === currentID);
  // console.log('currentSelectedSubMenuObj for reset:', currentSelectedSubMenuObj);
  if (currentSelectedSubMenuObj?.badgesInfo?.badge === true && window.toggleBadgeVisibility) {
    window.toggleBadgeVisibility(currentSelectedSubMenuObj);
  }
   if(window.selectedConfig.currentSelectedSubmenu == 'smart_mode' || window.selectedConfig.currentSelectedSubmenu == 'ecosystem'){
  document.getElementById('dimensionsWrapper').classList.remove('d-none');
 }
};

const showHotspot = (hotspotId) => {
 const hotspotData = window.selectedConfig.hotspotData || [];
const hotspotItem = hotspotData.find(
  h => h.hsname === hotspotId || h.htmlid === hotspotId
);

const currentHsId = window.selectedConfig.currentSelectedHotspot;

// console.log('showHotspot called for hotspotId:', hotspotId, 'currentHsId:', currentHsId);

// If currentHsId is set and different from new hotspot, remove active only from currentHsId hotspot
if (currentHsId && currentHsId !== hotspotId) {
  const currentHsEl = document.getElementById(currentHsId);
  if (currentHsEl?.classList.contains('active')) {
    // console.log(`Removing active from previous hotspot: ${currentHsId}`);
    currentHsEl.classList.remove('active');
  }
} 
// If currentHsId is null (first navigation), remove active from all active hotspots
else if (!currentHsId) {
  // console.log('No previous hotspot selected. Removing active from all hotspots.');
  document.querySelectorAll('.tempHotspot.active').forEach(el => {
    el.classList.remove('active');
  });
}

// Add active to new hotspot only if coming from Next/Previous navigation
const newHsEl = document.getElementById(hotspotId);
if (newHsEl && window.isNextPrevNavigation) {
  if (!newHsEl.classList.contains('active')) {
    newHsEl.classList.add('active');
  }
}

// Update currently selected hotspot
window.selectedConfig.currentSelectedHotspot = hotspotId;
};

const nextPreviousHandler = (mode, setActiveBtn) => {
  // console.log('nextPreviousHandler called with mode:', mode);
  // console.log('nextPreviousHandler called with mode:', mode);
  let nextPrevArray = [...window.config.nextPrevArray];
  // Filter out "Left Ports" menu items and firstButton from navigation 
  // firstButton (Left Ports) will be auto-triggered when ai_fusion_solution is selected
  // Dynamically determine which popup-first-buttons should be auto-triggered
  // and remove those popup entries + any duplicate standalone submenu entries from sequence
  const allSubmenu = [...(window.config.allSubmenu || [])];
  const autoTriggeredSeq = new Set();
  allSubmenu.forEach(sub => {
    if (sub && sub.popupBoxButtons && sub.popupBoxButtons.length > 0) {
      // popupBoxButtons usually contains an object with keys like firstButton, secondButton
      const pb = sub.popupBoxButtons[0];
      // try to pick the explicit firstButton or fallback to the first available value
      const first = pb.firstButton || Object.values(pb)[0];
      if (first && first.sequenceName) autoTriggeredSeq.add(first.sequenceName);
    }
  });

  nextPrevArray = nextPrevArray.filter(item => {
    // remove popup button entries that match an auto-triggered sequence
    if (item && item.type === 'popupBoxButton' && autoTriggeredSeq.has(item.sequenceName)) return false;
    // remove standalone submenu entries that duplicate an auto-triggered sequence
    // but DO NOT remove the parent menu that contains popupBoxButtons (we detect it via popupBoxButtons)
    if (
      item &&
      item.sequenceName &&
      autoTriggeredSeq.has(item.sequenceName) &&
      !item.parentSubmenuId &&
      (!item.items || item.items.length === 0) &&
      !item.popupBoxButtons
    ) return false;
    return true;
  });
  // console.log('currentSelectedSubmenu Original nextPrevArray:', nextPrevArray);

  // const alreadyMerged = nextPrevArray.some(item => item.parentSubmenuId);

  // if (!alreadyMerged) {
  //   const originalLength = nextPrevArray.length;
  //   let offset = 0;

  //   for (let i = 0; i < originalLength; i++) {
  //     const item = nextPrevArray[i + offset];
  //     if (item.hotspotDataInfo && Array.isArray(item.hotspotDataInfo)) {
  //       let insertIndex = i + offset + 1;
  //       item.hotspotDataInfo.forEach((dim, index) => {
  //         const dimId = dim.htmlid || dim.hsname || (dim.nameOf3dObj + '_dimension_' + index);
  //         const dimensionObject = { ...dim, type: 'dimension', id: dimId, parentSubmenuId: item.id };
  //         nextPrevArray.splice(insertIndex, 0, dimensionObject);
  //         window.config.nextPrevArray.splice(insertIndex, 0, dimensionObject);
  //         insertIndex++;
  //         offset++;
  //       });
  //     }
  //   }
  //   window.config.nextPrevArray = nextPrevArray;
  // }
  let currentSelectedSubmenu = window.selectedConfig.currentSelectedHotspot !== null ? window.selectedConfig.currentSelectedHotspot : window.selectedConfig.currentSelectedSubmenu;
  // let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
  let currentSelectedSubMenuIndex = window.selectedConfig.currentSelectedSubmenuIndex;
  // console.log('currentSelectedSubmenu :', currentSelectedSubMenuIndex);
  let hasNavigatedBefore = window.selectedConfig.hasNavigatedBefore === true;

  let indexByID = nextPrevArray.findIndex(menuList => menuList.id === currentSelectedSubmenu);

  if (currentSelectedSubMenuIndex === undefined || currentSelectedSubMenuIndex === null) {
    currentSelectedSubMenuIndex = indexByID !== -1 ? indexByID : 0;
  }

  if (indexByID !== -1 && nextPrevArray[currentSelectedSubMenuIndex]?.id !== currentSelectedSubmenu) {
    currentSelectedSubMenuIndex = indexByID;
  }

  // console.log('🔍 DEBUG nextPreviousHandler START - mode:', mode);
  // console.log('   currentSelectedSubmenu:', currentSelectedSubmenu);
  // console.log('   currentSelectedSubMenuIndex (before mode):', currentSelectedSubMenuIndex);
  // console.log('   hasNavigatedBefore:', hasNavigatedBefore);
  // console.log('   nextPrevArray length:', nextPrevArray.length);

  if (!hasNavigatedBefore) {
    if (mode === 'next') {
      currentSelectedSubMenuIndex = 0;
    } else if (mode === 'previous') {
      currentSelectedSubMenuIndex = nextPrevArray.length - 1;
    }
  } else {
    if (mode === 'next') {
      currentSelectedSubMenuIndex++;
      if (currentSelectedSubMenuIndex >= nextPrevArray.length) {
        currentSelectedSubMenuIndex = 0;
      }
    } else if (mode === 'previous') {
      currentSelectedSubMenuIndex--;
      if (currentSelectedSubMenuIndex < 0) {
        currentSelectedSubMenuIndex = nextPrevArray.length - 1;
      }
    }
  }

  // console.log('   currentSelectedSubMenuIndex (after mode):', currentSelectedSubMenuIndex);

  let nextElement = nextPrevArray[currentSelectedSubMenuIndex];
  // console.log('Next element:', nextElement);
  // console.log('Has badgesInfo?', nextElement.badgesInfo);

  // Helper function to hide all badges
  const hideAllBadges = () => {
    if (window.toggleBadgeVisibility) {
      // console.log('Hiding all badges');
      window.toggleBadgeVisibility({});
    }
  };
    
if(nextElement.hotspotDataInfo || nextElement.parentSubmenuId) {
    // Remove ONLY the currently selected hotspot's active class
    const currentHsId = window.selectedConfig.currentSelectedHotspot;
    if(currentHsId){
        const currentHsEl = document.getElementById(currentHsId);
        // Check if it exists and has 'active' class
        if(currentHsEl?.classList.contains('active')) {
            // currentHsEl.classList.remove('active');
        }
    }

    // Activate new hotspot
    const newHotspotId = nextElement.hsname || nextElement.htmlid;
    if(newHotspotId) {
        showHotspot(newHotspotId); // Adds .active and shows popup
        window.selectedConfig.currentSelectedHotspot = newHotspotId;
    }
}

  // Nested hotspot
  // if (nextElement.parentSubmenuId) {
  //   // console.log('NESTED HOTSPOT');
    
  //   let allSubmenu = [...window.config.allSubmenu];
  //   let parentSubmenuObj = allSubmenu.find(item => item.id === nextElement.parentSubmenuId);
    
  //   if (parentSubmenuObj && parentSubmenuObj.popupId) {
  //     const parentPopupElement = document.getElementById(parentSubmenuObj.popupId);
  //     if (parentPopupElement) {
  //       // console.log('Closing parent popup:', parentSubmenuObj.popupId);
  //       parentPopupElement.classList.remove('active');
  //     }
  //   }
    
  //   document.querySelectorAll('.popup.active').forEach(popup => {
  //     popup.classList.remove('active');
  //   });
    
  //   hideAllBadges();
    
  //   setTimeout(() => {
  //     handleHotspotClick(nextElement.parentSubmenuId, [nextElement], true);
  //   }, 150);
  // } 
  // 🔥 POPUP BUTTON VIA NEXT / PREVIOUS
if (nextElement.type === 'popupBoxButton') {
  // console.log('Popup button navigation:', nextElement);
  
  // Get parent submenu and accordion data
  const allSubmenu = [...window.config.allSubmenu];
  const parentSubmenuObj = allSubmenu.find(item => item.id === nextElement.parentSubmenuId);
  const parentAccordionId = nextElement.parentAccordionId;
  
  if (parentSubmenuObj) {
    // console.log("1111");
    //First activate the parent accordion
    const parentAccordion = window.config.nextPrevArray.find(item => item.id === parentAccordionId);
    if (parentAccordion) {
      accordionMenu(parentAccordion, "accordion_" + parentAccordionId, true);
    }
    
    // Then activate the parent submenu
    handleSubMenuClick(parentSubmenuObj, parentSubmenuObj.id, true, undefined, undefined, true);
    
    //Find and click the button element to trigger setActiveBtn in SubmenuList
    setTimeout(() => {
      const buttonEl = document.getElementById(nextElement.id);
      // console.log('Looking for button element:', nextElement.id, 'Found:', !!buttonEl);
      
      if (buttonEl) {
        // console.log('Clicking button to trigger setActiveBtn');
        // This will trigger the onClick handler which calls setActiveBtn and popupButtonClicks
        buttonEl.click();
      } else {
        // console.warn('Button not found, calling popupButtonClicks directly');
        // Fallback if button not found
        popupButtonClicks(nextElement);
      }
      
      // IMPORTANT: Reset currentSelectedSubmenu AFTER button click to prevent popupButtonClicks from overwriting it
      setTimeout(() => {
        window.selectedConfig.currentSelectedSubmenu = nextElement.id;
        // console.log('Reset currentSelectedSubmenu to:', nextElement.id);
      }, 50);
    }, 150);
  }
  
  hideAllBadges();

  // Update your selectedConfig - IMPORTANT: Find the correct index of this button in nextPrevArray
  const buttonIndex = nextPrevArray.findIndex(item => item.id === nextElement.id);
  // console.log('Button index in nextPrevArray:', buttonIndex, 'for button:', nextElement.id);
  
  window.selectedConfig.currentSelectedSubmenuIndex = buttonIndex !== -1 ? buttonIndex : currentSelectedSubMenuIndex;
  window.selectedConfig.hasNavigatedBefore = true;

  return; // Stop further execution here
}


  // Nested hotspot
  // console.log(nextElement.parentSubmenuId, nextElement.hotspotDataInfo);
else if (nextElement.parentSubmenuId) {
    // console.log("2222");
  // console.log("11111");
  // console.log('NESTED HOTSPOT');
  // alert('NESTED HOTSPOT');
  
  let allSubmenu = [...window.config.allSubmenu];
  let parentSubmenuObj = allSubmenu.find(item => item.id === nextElement.parentSubmenuId);
  
  if (parentSubmenuObj && parentSubmenuObj.popupId) {
    const parentPopupElement = document.getElementById(parentSubmenuObj.popupId);
    if (parentPopupElement) {
      // console.log('Closing parent popup:', parentSubmenuObj.popupId);
      parentPopupElement.classList.remove('active');
    }
  }
  
  document.querySelectorAll('.popup.active').forEach(popup => {
    popup.classList.remove('active');
  });
  
  hideAllBadges();

  let parentAccordion = nextPrevArray.find(item => item.id === nextElement.parentAccordionId);
  // console.log('parentAccordion ', parentAccordion);
  // let parentAccordion = window.config.nextPrevArray[0];
  // let submenu = window.config.nextPrevArray[5];
  let submenu = nextPrevArray.find(item => item.id === nextElement.parentSubmenuId);
  // if(mode === 'previous'){
  // }
  accordionMenu(parentAccordion, "accordion_" + parentAccordion.id, true);
  handleSubMenuClick(submenu, submenu.id, true, undefined, undefined, true);
    // handleSubMenuClick(submenu, submenu.id, true, undefined, undefined, true);
  setTimeout(() => {
    handleHotspotClick(nextElement.parentSubmenuId, [nextElement], true);
    
    // Activate parent submenu button in left menu
    document.querySelectorAll('.subMenuBtn.active').forEach(btn => {
      btn.classList.remove('active');
    });
    const parentMenuButton = document.querySelector(`#menu_id_${nextElement.parentSubmenuId}`);
    if (parentMenuButton) {
      parentMenuButton.classList.add('active');
    }
  }, 0);
  
}
  //Main accordion with items
  else if (nextElement.items && nextElement.items.length > 0) {
    // console.log("3333");
  // console.log("2222");
    // console.log('ACCORDION with items:', nextElement);
    // console.log('"accordion_" + nextElement.id', "accordion_" + nextElement.id);
    
    accordionMenu(nextElement, "accordion_" + nextElement.id, true);
    
    // Clear all active submenus in the accordion to prevent first submenu from being active
    const accordionElement = document.querySelector(`#accordion_${nextElement.id}`);
    if (accordionElement && accordionElement.nextSibling) {
      const accordionContent = accordionElement.nextSibling;
      accordionContent.querySelectorAll('.subMenuBtn.active').forEach(btn => {
        btn.classList.remove('active');
      });
    }
    
    if (nextElement.badgesInfo && nextElement.badgesInfo.badge === true && window.toggleBadgeVisibility) {
      // console.log('Accordion badge detected');
      setTimeout(() => {
        window.toggleBadgeVisibility(nextElement);
      }, 200);
    } else {
      // console.log('No badge for accordion');
      hideAllBadges();
    }
  }
  // AR Popup (keep this one, remove duplicate)
  else if (nextElement.id === 'arpopup') {
    // console.log('AR POPUP detected');
    
    accordionMenu(nextElement, "accordion_arpopup", true);
    
    setTimeout(() => {
      document.querySelectorAll('.popup.active').forEach(popup => {
        popup.classList.remove('active');
      });
      
      const arPopupId = nextElement.popupId || 'accordion_arpopup';
      const arPopup = document.getElementById(arPopupId);
      if (arPopup) {
        arPopup.classList.add('active');
      }
    }, 300);
    
    if (nextElement.badgesInfo && nextElement.badgesInfo.badge === true && window.toggleBadgeVisibility) {
      // console.log('Accordion badge detected');
      setTimeout(() => {
        window.toggleBadgeVisibility(nextElement);
      }, 200);
    } else {
      hideAllBadges();
    }
  }
  // Regular submenu item
  else {
  // console.log("4444");
    // console.log('SUBMENU item:', nextElement.id);
    handleSubMenuClick(nextElement, nextElement.id, true, undefined, undefined, true);
    
    // 🔥 AUTO-TRIGGER FIRST POPUP BUTTON IF THIS IS "All the ports you need – and more!"
    if (nextElement.id === 'color' && nextElement.popupBoxButtons && nextElement.popupBoxButtons.length > 0) {
      // console.log('🔥 Auto-triggering first popup button for ai_fusion_solution');
      setTimeout(() => {
        const firstButton = nextElement.popupBoxButtons[0].firstButton;
        if (firstButton) {
          // Find the button element and click it
          const buttonEl = document.getElementById(firstButton.id);
          if (buttonEl) {
            // console.log('Auto-clicking firstButton:', firstButton.id);
            buttonEl.click();
          } else {
            // Fallback: directly call popupButtonClicks
            firstButton.type = 'popupBoxButton'; // Mark it as popup button
            popupButtonClicks(firstButton);
          }
        }
      }, 150);
    }
    
    setTimeout(() => {
         window.UiUtils.adjustMenuHeight();      
    }, 500);
    
    if (nextElement.badgesInfo && nextElement.badgesInfo.badge === true && window.toggleBadgeVisibility) {
      // console.log('Submenu badge detected for:', nextElement.id);
      setTimeout(() => {
        window.toggleBadgeVisibility(nextElement);

      }, 200);
    } else {
      // console.log('No badge for submenu');
      hideAllBadges();
    }
  }

  window.selectedConfig.currentSelectedSubmenuIndex = currentSelectedSubMenuIndex;
  window.selectedConfig.currentSelectedSubmenu = nextElement.id;
  window.selectedConfig.hasNavigatedBefore = true;
  
  // console.log('Navigation complete to:', window.selectedConfig.currentSelectedHotspot);
  // console.log('Navigation complete to:', nextElement);
//     if(window.selectedConfig.currentSelectedSubmenu == 'smart_mode' || window.selectedConfig.currentSelectedSubmenu == 'ecosystem' || nextElement.type == 'dimension'){
//       document.getElementById('dimensionsWrapper').classList.remove('d-none');
//  }
};




    /*Footer Controls End */

// console.log('FooterControl called..... window.isDesktopView ', window.isDesktopView)
// console.log('FooterControl called..... !window.isMobIsipadIsPotrait ', !window.isMobIsipadIsPotrait)
// console.log("handleHotspotClick in app.js", typeof handleHotspotClick, handleHotspotClick);

  return (
    <>
      <div className='leftMenuWrapper' id='leftMenuWrapper'>
        {(!window.isMobIsipadIsPotrait) && <div id="menuHideShow" className="d-none">
          <img src="./images/menu/closemenu.png" alt="cross" className="crossIcon" />
          <span id="viewfeature" className="d-none">{ui.viewFeatureText}</span>
        </div>}
        {!window.isMobIsipadIsPotrait ? (
        <div id="menuWprappper">
         <div className="logo_div">
            <img className="" alt="" src={ui.logoImage} />
            {/* <img className="plusIcon" alt="" src={ui.plusIcon} /> */}
            <img className="intelBadge" alt="" src={ui.intelBadge} />
          </div>
          
          <div className="title_div" style={{ width: '235px' }}>
            <h2>{ui.ProjectTitle}</h2>
          </div>
           <Menu handleHotspotClick={handleHotspotClick} popupButtonClicks={popupButtonClicks} count={count} isFirstAccordion={isFirstAccordion} ui={ui} QRSupport={QRSupport} menuSubmenu={menuSubmenu} onLoadActiveradioButton={onLoadActiveradioButton} onLoadActiveAccordionMobile={onLoadActiveAccordionMobile} accordionMenuclick={accordionMenu} handleSubMenuClick={handleSubMenuClick} filterMenuBasedOnConfigType={filterMenuBasedOnConfigType} calcHtmlElementNoWrapWidth={calcHtmlElementNoWrapWidth} cssVariableValues={cssVariableValues}></Menu>
                 {<HowToUse count={count} ui={ui} QRSupport={QRSupport} /> }

        </div>) : (
          <>
           <Menu
            handleHotspotClick={handleHotspotClick}
            popupButtonClicks={popupButtonClicks}
            count={count}
            isFirstAccordion={isFirstAccordion}
            ui={ui}
            QRSupport={QRSupport}
            menuSubmenu={menuSubmenu}
            onLoadActiveradioButton={onLoadActiveradioButton}
            onLoadActiveAccordionMobile={onLoadActiveAccordionMobile}
            accordionMenuclick={accordionMenu}
            handleSubMenuClick={handleSubMenuClick}
            filterMenuBasedOnConfigType={filterMenuBasedOnConfigType}
            calcHtmlElementNoWrapWidth={calcHtmlElementNoWrapWidth}
            cssVariableValues={cssVariableValues}
          />


            {/* <div className="mobProjectTitle_HowToUse"> */}
              {<ProjectTitleMob ui={ui} />}
              {<HowToUse count={count} ui={ui} QRSupport={QRSupport} /> }

            {/* </div> */}
          </>
       )}
      </div>

      {(!window.isMobIsipadIsPotrait) && <FooterControl count={count} ui={ui} onNext={onNextMode} onPrevious={onPreviousMode} onReset={onReset}></FooterControl>}
      {(!window.isMobIsipadIsPotrait) && <ResetView onReset={onReset}></ResetView>}
      {<GlobalDisclaimer ui={ui} />}
      {<OverviewText ui={ui} />}
    </>
  );
}

export default App;
